
import { defineComponent } from "vue";
import { IDisplaySection } from "@/types/location";
import { addressJoiner } from "@/util/helpers";
import { zipObject, map } from "lodash-es";
import { useLocation, useMap } from "@/services";
import CoordinateEditor from "@/components/drawers/left/CoordinateEditor.vue";

export default defineComponent({
  name: "DisplaySection",
  components: { CoordinateEditor },
  props: {
    section: {
      type: Object as () => IDisplaySection,
      default: () => ({} as IDisplaySection),
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isSectionOpen: false,
  }),
  computed: {
    isEditingCoordinates: {
      get(): boolean {
        return useMap().isEditingCoordinates;
      },
      set(val: boolean) {
        useMap().isEditingCoordinates = val;
      },
    },
    postcode(): string {
      return (
        this.section.type === "Address" &&
        this.section.items.find((i) => i.name === "Postcode")?.value
      );
    },
    coordinates(): string {
      return (
        (this.section.type === "Coordinate" &&
          `${this.section.items[0].value}`) ||
        ""
      );
    },
    isDatasetRecord(): boolean {
      return !!useLocation().location?.record;
    },
    isCoordinateUpdatable(): boolean {
      return !!useLocation().location?.record?.columnDefinitions.find(
        (x) => x.type === "Geometry"
      )?.updatable;
    },
    isTable(): boolean {
      return this.section.type === "Table";
    },
    entry(): Record<string, unknown> {
      return this.isTable
        ? zipObject(
            map(this.section.items, "name") as string[],
            map(this.section.items, "value")
          )
        : {};
    },
  },
  mounted() {
    if (this.isOpen) {
      this.isSectionOpen = true;
    }
  },
  methods: {
    addressJoiner,
    toggleTable() {
      this.isSectionOpen = !this.isSectionOpen;
    },
    getEntryFields(entry: Record<string, unknown>) {
      return Object.keys(entry).filter(
        (key) => this.isFiniteNumber(entry[key]) || entry[key]
      );
    },
    isFiniteNumber(o: unknown) {
      return typeof o === "number" && isFinite(o);
    },
  },
});
